// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminExecutionEvents = {
  actions: {
    retry: "重试",
    retryTask: "重试任务",
    processAutoRetries: "处理到期自动重试",
  },
  drawer: {
    title: "执行任务 #{id}",
    titleShort: "执行任务",
    eventTitle: "运行事件 #{id}",
    eventTitleShort: "运行事件",
    rawEventTitle: "原始事件 #{id}",
    rawEventTitleShort: "原始事件",
    requestPayload: "请求载荷",
    resultPayload: "执行结果",
  },
  fields: {
    taskId: "关联任务 ID",
    eventAction: "关联动作",
    eventTrigger: "触发器",
    workerId: "执行器 ID",
    requiredCapability: "所需能力",
    dispatchDecision: "调度结论",
    leaseOwner: "租约持有者",
    leaseExpiresAt: "租约到期时间",
    retrySource: "重试来源",
    rootTask: "根任务",
    retryDepth: "重试深度",
    retryCount: "已发起重试",
    autoRetryEnabled: "自动重试",
    autoRetryState: "自动重试状态",
    autoRetryMax: "自动重试上限",
    autoRetryDelay: "自动重试间隔",
    nextRetryAt: "下一次重试",
    latestRetry: "最新重试",
    startTime: "开始时间",
    finishTime: "结束时间",
  },
  columnHelp: {
    event: "这条记录描述发生了什么平台事件，已按较容易理解的名称展示。",
    resource: "这条事件影响到的对象，例如执行任务或环境实例。",
    status: "这条事件当前记录的结果状态，不等于完整技术日志。",
    eventConclusion: "基于状态、调度结论和载荷摘要提炼出的面向业务/治理视角的结果说明。",
    eventCategory: "按任务、调度、租约、恢复等大类归纳事件，便于快速浏览。",
  },
  messages: {
    taskDetailLoadFailed: "加载任务详情失败",
    taskRetryStarted: "已发起重试任务 #{id}",
    taskRetryFailed: "任务重试失败",
    autoRetryProcessed: "已扫描 {scanned} 条，触发 {triggered} 条，派发失败 {dispatchFailed} 条",
    autoRetryProcessFailed: "处理自动重试失败",
  },
  values: {
    retryable: "可重试",
    retried: "已重试",
    succeeded: "已成功",
    exhausted: "不可重试",
    retryScheduled: "待自动重试",
    scheduled: "待自动重试",
    processing: "处理中",
    dispatchRetried: "已触发重试",
    dispatchFailed: "派发失败",
    deadLettered: "已进入死信",
    manualInterventionRequired: "需要人工介入",
    autoRetryExhausted: "自动重试耗尽",
    pending: "待执行",
    running: "执行中",
    success: "成功",
    failed: "失败",
    cancelled: "已取消",
    eventTaskPending: "任务进入待执行",
    eventTaskClaimed: "任务已领取",
    eventTaskClaimReleased: "任务领取已释放",
    eventTaskRunning: "任务开始执行",
    eventTaskSucceeded: "任务执行成功",
    eventTaskFailed: "任务执行失败",
    eventTaskCancelled: "任务已取消",
    eventTaskCancellationRequested: "已发起取消请求",
    eventTaskLeaseRenewed: "任务租约已续期",
    eventTaskClaimConflicted: "任务领取发生冲突",
    eventTaskDispatchCapabilityMismatch: "派发能力不匹配",
    eventTaskDispatchRateLimited: "派发触发限流",
    eventTaskAutoRetryDispatchFailed: "自动重试派发失败",
    eventTaskAutoRetryDeadLettered: "自动重试已进入死信",
    eventTaskAutoRetryManualInterventionRequired: "自动重试需要人工介入",
    eventTaskStaleRunningDetected: "运行中任务进入异常恢复",
    eventStatusRecorded: "已记录",
    eventCategoryTask: "任务",
    eventCategoryDispatch: "调度",
    eventCategoryLease: "租约",
    eventCategoryRecovery: "恢复",
    eventCategoryOther: "其他",
    resourceExecutionTask: "执行任务",
    resourceEnvironmentInstance: "环境实例",
    resourceExecutionTaskWithId: "执行任务 #{id}",
    resourceEnvironmentInstanceWithId: "环境实例 #{id}",
    eventConclusionSuccess: "已完成并记录成功结果",
    eventConclusionFailed: "执行已失败，需要排查",
    eventConclusionFailedWithReason: "执行失败：{reason}",
    eventConclusionRetryState: "当前处于重试状态：{value}",
  },
} as const;
